import { isMobile } from 'react-device-detect';
import { CreateCompanyInvitationDTOPlanEnum } from '../api-client/generated';
import {
  DASHBOARD_TAB,
  CALENDAR_TAB,
  PROJECT_TAB,
  CUSTOMER_TAB,
  LEAD_TAB,
  CHAT_TAB,
  TIMESHEET,
  CATALOG_TAB,
  RESOURCES_TAB,
  RESOURCES_OPT_TAB,
  COMPANIES_TAB,
  RESOURCES_ADMIN_TAB,
  CUSTOMER_INVOICES_TAB,
  CUSTOMER_INFORMATION_TAB,
  CUSTOMER_PROPOSAL_TAB,
  CUSTOMER_SERVICE_REQUESTS_TAB,
  CUSTOMER_PROJECT_TAB,
  CATALOG_SUPERUSER_TAB,
  PROPOSAL_CATALOG_TAB,
  MY_NETWORK_TAB,
  SERVICE_REQUESTS_TAB,
  INSPECTIONS_TAB,
  MY_SCHEDULE_TAB,
  MY_SITES_TAB,
  MY_VISITS_TAB
} from '../helpers/navItems';
import { ROLES } from '../helpers/roles';

interface menuTabsProps {
  children?: {
    route: string;
    text: string;
  }[];
  icon: string;
  position: number;
  route: string;
  text: string;
}

interface UserState {
  active: boolean;
  block: boolean;
  email: string | undefined;
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
  mfa: boolean;
  roles: string[] | [];
  setUser: (data: any) => void;
  timeFormat?: string;
}

function filterUniquePositionsWithMaxLength(
  menuTabs: menuTabsProps[]
): menuTabsProps[] {
  const positions: {
    [position: number]: { childrenLength: number; tab: menuTabsProps };
  } = {};
  const result: menuTabsProps[] = [];
  menuTabs.forEach((tab) => {
    const { position } = tab;
    const childrenLength = tab.children ? tab.children.length : 0;
    if (
      !positions[position] ||
      childrenLength > positions[position].childrenLength
    ) {
      positions[position] = { childrenLength, tab };
    }
  });
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const position in positions) {
    result.push(positions[position].tab);
  }

  return result;
}

export default function useOrderTabByRole(userState: UserState, company?: any) {
  if (!userState.roles) {
    return [];
  }
  const userRoles = [...userState.roles];
  const menuTabs: menuTabsProps[] = [];
  //  We add the tabs according to the company restrictions
  if (company?.plan === CreateCompanyInvitationDTOPlanEnum.Calculator) {
    userRoles.forEach((el) => {
      switch (el) {
        case ROLES.OPERATIONS:
          menuTabs.push(
            CUSTOMER_TAB,
            LEAD_TAB,
            CATALOG_TAB,
            PROPOSAL_CATALOG_TAB,
            RESOURCES_OPT_TAB
          );
          break;
        case ROLES.ADMINISTRATOR:
          menuTabs.push(RESOURCES_ADMIN_TAB, CATALOG_TAB);
          break;
        case ROLES.SUPER_USER:
          menuTabs.push(
            COMPANIES_TAB,
            RESOURCES_TAB,
            CATALOG_SUPERUSER_TAB
            // CALENDAR_TAB
          );
          break;
        default:
          break;
      }
    });
  } else if (isMobile && userRoles.includes(ROLES.SUPERVISOR)) {
    // Mobile supervisor: only supervisor screens regardless of other roles.
    // Supervisor can coexist with any role (Operations, Sales, Finance, Admin,
    // Business Development) but never with Technician. On mobile the field
    // context takes over — operator tabs are not shown.
    menuTabs.push(
      MY_SITES_TAB,
      MY_VISITS_TAB,
      MY_SCHEDULE_TAB,
      INSPECTIONS_TAB
    );
  } else {
    // We Add the tabs according to the role. User can have more tha one role.
    userRoles.forEach((el) => {
      switch (el) {
        case ROLES.OPERATIONS:
          menuTabs.push(
            DASHBOARD_TAB,
            CALENDAR_TAB,
            PROJECT_TAB,
            CUSTOMER_TAB,
            LEAD_TAB,
            CHAT_TAB,
            TIMESHEET,
            CATALOG_TAB,
            PROPOSAL_CATALOG_TAB,
            RESOURCES_OPT_TAB
          );
          if (company?.partnerNetworkEnabled) {
            menuTabs.push(MY_NETWORK_TAB);
          }
          menuTabs.push(SERVICE_REQUESTS_TAB);
          if (company?.inspectionsEnabled || company?.abeInspectEnabled) {
            menuTabs.push(INSPECTIONS_TAB);
          }
          break;
        case ROLES.SALES:
          menuTabs.push(
            CUSTOMER_TAB,
            LEAD_TAB,
            CATALOG_TAB,
            PROPOSAL_CATALOG_TAB
          );
          break;
        case ROLES.BUSINESS_DEVELOPMENT:
          menuTabs.push(CUSTOMER_TAB);
          break;
        case ROLES.TECHNICIAN:
          menuTabs.push(DASHBOARD_TAB, CALENDAR_TAB, CHAT_TAB, TIMESHEET);
          if (company?.inspectionsEnabled || company?.abeInspectEnabled) {
            menuTabs.push(INSPECTIONS_TAB);
          }
          break;
        case ROLES.ADMINISTRATOR:
          menuTabs.push(RESOURCES_ADMIN_TAB, CATALOG_TAB);
          break;
        case ROLES.FINANCE:
          menuTabs.push(PROJECT_TAB, CUSTOMER_TAB, TIMESHEET);
          break;
        case ROLES.SUPER_USER:
          menuTabs.push(COMPANIES_TAB, RESOURCES_TAB, CATALOG_SUPERUSER_TAB);
          break;
        case ROLES.SUPERVISOR:
          menuTabs.push(
            MY_SITES_TAB,
            MY_VISITS_TAB,
            MY_SCHEDULE_TAB,
            INSPECTIONS_TAB
          );
          break;
        case ROLES.CUSTOMER:
          menuTabs.push(
            CUSTOMER_PROJECT_TAB,
            CUSTOMER_INVOICES_TAB,
            CUSTOMER_INFORMATION_TAB,
            CUSTOMER_PROPOSAL_TAB,
            CUSTOMER_SERVICE_REQUESTS_TAB
          );
          break;
        default:
          break;
      }
    });
  }

  const filteredMenuTabs = filterUniquePositionsWithMaxLength(menuTabs);
  return filteredMenuTabs.sort((a, b) => a.position - b.position);
}
